module.exports = __webpack_public_path__ + "media/3-star-wish-reveal.03826eb0.ogg";